import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./SCORADassessment.css";

const SCORADassessment = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id") || "";
  const [nhsNumber, setNhsNumber] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const handleSubmit = async () => {
    if (!nhsNumber || !mobile || loading) return;
    setLoading(true);
    try {
      const res = await lifestyleApi.scoradLogin({ id, nhsNumber, mobile });
      const link = res.data.data?.scoradLink || "";
      if (link) window.location.href = link;
    } catch (err) {
      console.error("scoradLogin:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="scorad-assess-page">
      <div className="scorad-assess-container">
        <div className="scorad-assess-field">
          <label className="scorad-assess-label">{t("scoradAssess.nhsLabel")}</label>
          <input
            type="text"
            className="scorad-assess-input"
            value={nhsNumber}
            onChange={(e) => setNhsNumber(e.target.value)}
            placeholder={t("scoradAssess.nhsPlaceholder")}
          />
        </div>
        <div className="scorad-assess-field">
          <label className="scorad-assess-label">{t("scoradAssess.mobileLabel")}</label>
          <input
            type="tel"
            className="scorad-assess-input"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder={t("scoradAssess.mobilePlaceholder")}
          />
        </div>
      </div>
      <section className="scorad-assess-bottom">
        <button
          className="scorad-assess-btn"
          disabled={!nhsNumber || !mobile || loading}
          onClick={handleSubmit}
        >
          {loading ? t("common.loading") : t("scoradAssess.startBtn")}
        </button>
      </section>
    </section>
  );
};

export default SCORADassessment;
